import {
    collapseListener,
    collapseActivator,
} from '@js/utilities/bootstrap-modules-controller/drafts/collapseController';
import {
    tabListener,
    tabActivator,
} from '@js/utilities/bootstrap-modules-controller/drafts/tabController';

import {
    getState,
    clearState,
} from '@js/utilities/bootstrap-modules-controller/bootstrapModulesHelpers';

let eventAddedBefore = false;

export const bootstrapModulesController = () => {
    const elements = [...document.querySelectorAll('[data-bs-toggle]')].filter(
        (el) => !el.dataset.bootstrapModulesControllerInitialized
    );

    const collapseElements = elements.filter((el) => el.dataset.bsToggle === 'collapse');
    const tabElements = elements.filter((el) => el.dataset.bsToggle === 'tab');

    collapseListener(collapseElements);
    tabListener(tabElements);

    if (!eventAddedBefore) {
        window.addEventListener('beforeunload', () => {
            clearState();
        });

        eventAddedBefore = true;
    }
};

const getModuleState = (state, moduleSlug) =>
    Object.keys(state).reduce(
        (acc, key) => (state[key].toggle === moduleSlug ? { ...acc, [key]: state[key] } : acc),
        {}
    );

export const bootstrapModulesActivator = (html) => {
    let DOM = new DOMParser().parseFromString(html, 'text/html');

    const state = getState();

    const collapseState = getModuleState(state, 'collapse');
    const tabState = getModuleState(state, 'tab');

    DOM = collapseActivator(DOM, collapseState);
    DOM = tabActivator(DOM, tabState);

    return DOM.firstChild.outerHTML;
};
